import { Component, OnInit, Inject } from '@angular/core';
import { ImagenService } from 'src/app/servicios/imagen.service';
import { DomSanitizer } from '@angular/platform-browser';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-select-item',
  templateUrl: './dialog-select-item.component.html',
  styleUrls: ['./dialog-select-item.component.css']
})
export class DialogSelectItemComponent implements OnInit {

  origen:any;
  data=[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<DialogSelectItemComponent>
  ) { 
    this.origen=dataDialog.origen;
    this.data=dataDialog.data;
  }

  ngOnInit() {
  }

  selectedItem(item){
    this.cerrar(item);
  }

  cerrar(data){
    let event='';
    if(data=='cerrar'){
      event='cerrar';
    }
    else{
      event='check'
    }
    this.dialogRef.close({event:event, origen:this.origen, data:data});
  }

}
